import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatText'
})
export class FormatTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }

    // Divide o texto em linhas
    const lines = value.split('\n');

    // Processa cada linha
    const formattedLines = lines.map(line => {
      // Verifica se a linha começa com ** (título)
      if (line.startsWith('**')) {
        // Remove os ** e coloca a linha dentro de <h4>
        return `<h4>${line.replace(/\*\*/g, '').trim()}</h4>`;
      } else {
        return `<p>${line.trim()}</p>`;
      }
    });
    // Junta as linhas formatadas em uma única string
    return formattedLines.join('\n');
  }
}
